import { Row } from 'reactstrap';
import styled from 'styled-components';
import { ExpandButton, getTheme } from 'mol-ui';

export const ButtonDiv = styled.div `
    align-items: center;
    display: flex;
    justify-content: left;
    height: 80px;
    @media(max-width: 600px) {
        justify-content: center;
    }
`;

export const Container = styled.div `
    display: flex;
    align-items: start;
    width: 100%;
`;

export const Message = styled.div`
    color: ${ getTheme('textColor') };
    font-size: 15px;
    margin-top: 20px;
`;

export const NoPrintButton = styled(ExpandButton)`
    @media print {
        display: none !important;
    }
`;

export const PrintHeadTitle = styled.span`
    font-weight: bold;
    font-size: 16px;
`;

export const PrintItem = styled.span`
    font-weight: bold;
    font-size: 14px;
`;

export const PrintOnlyContainer = styled.div `
    @media screen {
        display: none!important;
    }
    @media print {
        display: block;
    }
`;

export const PrintText = styled.span `
    font-size: 14px;
`;

export const PrintTitle = styled.span `
    text-decoration: underline;
    font-weight: bold;
    font-size: 16px;
`;

export const ScreenOnlyContainer = styled.div `
    @media print {
        display: none!important;
    }
`;

export const StyledRow = styled(Row)`
    margin-left: 20px;
    width: 60%;
`;

export const Title = styled.p `
    color: ${ getTheme('textColor') };
    font-size: 1.3rem;
    font-weight: bolder;
    padding: 20px 20px;
`;

export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0px;
`;
